export function parseToDateString(date) {
	return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function getDateOfWeek(date) {
	const dayOfWeek = date.getDay(); // 0 = Sunday, 1 = Monday, etc.
	const dayKeys = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	return dayKeys[dayOfWeek];
}

export function getStartDateOfMonth(month, year) {
	return new Date(year, month, 1);
}

export function getEndDateOfMonth(month, year) {
	return new Date(year, month + 1, 0);
}

export function isEndOfMonth(date) {
	const endDateOfMonth = getEndDateOfMonth(date.getMonth(), date.getFullYear());
	return date.getDate() === endDateOfMonth.getDate();
}


/**
 * Format date from YYYYMMDD to readable format
 * @param {string} dateStr - Date string in YYYYMMDD format
 * @returns {string} Formatted date
 */
export function formatDateToReadable(dateStr) {
	if (!dateStr || dateStr.length !== 8) return dateStr;

	const year = parseInt(dateStr.substring(0, 4), 10);
	const month = parseInt(dateStr.substring(4, 6), 10) - 1;
	const day = parseInt(dateStr.substring(6, 8), 10);

	const date = new Date(year, month, day);

	const locale = wpcore.direct_t({ en: 'en-US', fr: 'fr-FR' });
	return date.toLocaleDateString(locale, {
		weekday: 'long',
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	});
}

/**
 * Convert Date object to Local MySQL DateTime string
 * @param {Date} date
 * @returns {string} YYYY-MM-DD HH:mm:ss
 */
export function convertDateToLocal(date) {
	if (!date) return '';
	const pad = (n) => n.toString().padStart(2, '0');
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function formatDate(dateStr, full = false) {
	if (!dateStr) return '';
	const date = new Date(dateStr.replace(/-/g, '/')); // Fix for Safari/iOS

	const months = [
		wpcore.direct_t({ en: 'Jan', fr: 'Janv' }),
		wpcore.direct_t({ en: 'Feb', fr: 'F\u00e9vr' }),
		wpcore.direct_t({ en: 'Mar', fr: 'Mars' }),
		wpcore.direct_t({ en: 'Apr', fr: 'Avr' }),
		wpcore.direct_t({ en: 'May', fr: 'Mai' }),
		wpcore.direct_t({ en: 'Jun', fr: 'Juin' }),
		wpcore.direct_t({ en: 'Jul', fr: 'Juil' }),
		wpcore.direct_t({ en: 'Aug', fr: 'Ao\u00fbt' }),
		wpcore.direct_t({ en: 'Sep', fr: 'Sept' }),
		wpcore.direct_t({ en: 'Oct', fr: 'Oct' }),
		wpcore.direct_t({ en: 'Nov', fr: 'Nov' }),
		wpcore.direct_t({ en: 'Dec', fr: 'D\u00e9c' }),
	];
	const month = months[date.getMonth()];
	const day = date.getDate();

	if (!full) {
		return `${month} ${day}`;
	}

	const year = date.getFullYear();
	let hours = date.getHours();
	const minutes = date.getMinutes().toString().padStart(2, '0');
	const ampm = hours >= 12 ? wpcore.direct_t({ en: 'PM', fr: 'PM' }) : wpcore.direct_t({ en: 'AM', fr: 'AM' });
	hours = hours % 12;
	hours = hours ? hours : 12; // 0 should be 12

	return `${month} ${day}, ${year}, ${hours}:${minutes} ${ampm}`;
}
